// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-help-__slug-index-wrapper-guywt{display:grid;grid-gap:24px}.pages-help-__slug-index-pageWrapper-bsvah{padding-bottom:48px}.pages-help-__slug-index-pageWrapper-bsvah.pages-help-__slug-index-mobile-biiik{padding-top:48px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "pages-help-__slug-index-wrapper-guywt",
	"pageWrapper": "pages-help-__slug-index-pageWrapper-bsvah",
	"mobile": "pages-help-__slug-index-mobile-biiik"
};
module.exports = ___CSS_LOADER_EXPORT___;
